var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ui icon blue button back-to-top",attrs:{"data-tooltip":_vm.$t('ui.toolbox.back_to_top_button.back_to_top')}},[_c('i',{staticClass:"long arrow up icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }